mutation ReplaceAssetReferences($fromAssetId: ID!, $toAssetId: ID!) {
  result: StreamToolsReplaceAssetReferences(
    fromAssetId: $fromAssetId
    toAssetId: $toAssetId
  ) {
    fromAssetId
    toAssetId
    repointed
    skippedChanged
    failed
    merchBoardsRepointed
    complete
  }
}
